import { getCookie } from './getCookie';
import { isEmpty } from './isEmpty';

export const getCountryCodeCookie = () => {
  let userCountryCode = getCookie('OU_CountryCode');

  const [code, pricingAreaCode] = userCountryCode.split('|');

  if (isEmpty(code) || isEmpty(pricingAreaCode)) {
    return undefined;
  }

  return {
    code,
    pricingAreaCode,
  };
};
